import { isLaunchNext } from "./fragment";
import type { LaunchNext } from "./fragment";

/**
 * 런치 프래그먼트의 `next`(4.6 §4.3 — `…/sso#bffToken=…&next=course`)를 세션이 설 때까지 맡겨 둔다.
 * 부팅 때 {@link rememberLaunchNext} 로 넣고, 입장 화면(FS-01-01)이 세션을 세운 뒤 {@link takeLaunchNext} 로 한 번 꺼낸다(꺼내면 지운다).
 * sessionStorage(없으면 메모리) — 같은 탭에서 새로 고침해도 입장이 끝나기 전이면 남는다.
 */
const KEY = "pf.launch.next";
let memory: LaunchNext | null = null;

/** 런치 키가 있는 새 입장이면 부른다 — next 가 없으면 옛 값을 지운다 */
export function rememberLaunchNext(next: LaunchNext | null | undefined): void {
  memory = next ?? null;
  try {
    if (memory) window.sessionStorage.setItem(KEY, memory);
    else window.sessionStorage.removeItem(KEY);
  } catch {
    /* 저장소 없음 — 메모리만 */
  }
}

export function peekLaunchNext(): LaunchNext | null {
  try {
    const v = window.sessionStorage.getItem(KEY);
    if (isLaunchNext(v)) return v;
  } catch {
    /* 메모리 */
  }
  return memory;
}

/** 한 번 꺼내고 지운다 */
export function takeLaunchNext(): LaunchNext | null {
  const v = peekLaunchNext();
  rememberLaunchNext(null);
  return v;
}
